export const notificationFragment = gql`
  fragment NotificationFragment on Notification {
    id
    userId
    integrationId
    type
    behavior
    title
    body
    actionLabel
    actionUrl
    metadata
    incidentSequence
    readAt
    resolvedAt
    createdAt
    updatedAt
    integration {
      id
      type
      description
      parentId
      parent {
        id
        description
      }
    }
  }
`;

export const notificationPreferenceFragment = gql`
  fragment NotificationPreferenceFragment on NotificationPreference {
    id
    userId
    type
    channel
    enabled
    createdAt
    updatedAt
  }
`;

export const NOTIFICATIONS_QUERY = gql`
  query NotificationsQuery($limit: Int, $includeResolved: Boolean) {
    notifications(limit: $limit, includeResolved: $includeResolved) {
      ...NotificationFragment
    }
  }

  ${notificationFragment}
`;

export const NOTIFICATION_HISTORY_QUERY = gql`
  query NotificationHistoryQuery($limit: Int) {
    notificationHistory(limit: $limit) {
      ...NotificationFragment
    }
  }

  ${notificationFragment}
`;

export const NOTIFICATION_HISTORY_COUNT_QUERY = gql`
  query NotificationHistoryCountQuery {
    notificationHistoryCount
  }
`;

export const UNREAD_NOTIFICATIONS_COUNT_QUERY = gql`
  query UnreadNotificationsCountQuery {
    unreadNotificationsCount
  }
`;

export const NOTIFICATION_PREFERENCES_QUERY = gql`
  query NotificationPreferencesQuery {
    notificationPreferences {
      ...NotificationPreferenceFragment
    }
  }

  ${notificationPreferenceFragment}
`;

export const MARK_NOTIFICATION_READ_MUTATION = gql`
  mutation MarkNotificationReadMutation($id: String!) {
    markNotificationRead(id: $id) {
      ...NotificationFragment
    }
  }

  ${notificationFragment}
`;

export const UPDATE_NOTIFICATION_PREFERENCE_MUTATION = gql`
  mutation UpdateNotificationPreferenceMutation(
    $type: NotificationPreferenceType!
    $channel: NotificationChannel!
    $enabled: Boolean!
  ) {
    updateNotificationPreference(
      type: $type
      channel: $channel
      enabled: $enabled
    ) {
      ...NotificationPreferenceFragment
    }
  }

  ${notificationPreferenceFragment}
`;

export const UNSUBSCRIBE_NOTIFICATION_PREFERENCE_MUTATION = gql`
  mutation UnsubscribeNotificationPreferenceMutation($token: String!) {
    unsubscribeNotificationPreference(token: $token)
  }
`;
